import { AfterContentChecked, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { CustomerObjectContactDto, CustomerObjectWithContactsDto, getContragentContactDisplayName as resolveContragentContactDisplayName } from "../../../../../models/customerObject/customer-object-with-contacts.dto";
import { GridComponent } from "@progress/kendo-angular-grid";
import { CustomerObjectsService } from "../../../../../../categories/customer-objects/customer-objects.service";
import { DropdownListCountryPhoneMasksComponent } from "../../../../dropdownlist-country-phone-masks/dropdownlist-country-phone-masks.component";

@Component({
	selector: 'request-page-customer-object-contacts',
	templateUrl: './request-page-customer-object-contacts.component.html',
	styleUrls: ['./request-page-customer-object-contacts.component.scss',
		'../../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class RequestPageCustomerObjectContactsComponent implements OnInit, OnChanges {

	@ViewChild("contactsGrid") contactsGrid: GridComponent;
	@ViewChild('countryPhoneMasksComponent') countryPhoneMasksComponent: DropdownListCountryPhoneMasksComponent;

	@Input() contragentId: number;
	@Input() customerObjectId: number;
	@Input() collapseCard: boolean = true;

	customerObject: CustomerObjectWithContactsDto = { contacts: [] } as CustomerObjectWithContactsDto;
	loading: boolean = false;
	cardOpened: boolean = false;

	cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};

	constructor(
		private customerObjectsService: CustomerObjectsService
	) { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.contragentId || changes.customerObjectId) {
			this.initData();
		}
	}

	ngOnInit(): void {
		this.initData();
	}

	initData() {
		if (this.customerObjectId) {
			this.loading = true;
			this.customerObjectsService.getCustomerObjectWithContacts(this.customerObjectId).subscribe(resp => {
				this.customerObject = resp;
				this.loading = false;
			});
		}
	}

	saveContactHandler({ dataItem }: any) {
		let updatedCustomerObject = { ...this.customerObject };
		if (dataItem.contactId && dataItem.contactId != 0) {
			let updatedContactId = updatedCustomerObject.contacts.findIndex(x => x.contactId == dataItem.contactId);
			updatedCustomerObject.contacts[updatedContactId] = dataItem;
		}
		else {
			updatedCustomerObject.contacts.push(dataItem);
		}
		this.refreshContactsHandler(updatedCustomerObject);
	}

	removeContactHandler({ dataItem }: any) {
		let updatedCustomerObject = { ...this.customerObject };
		updatedCustomerObject.contacts = updatedCustomerObject.contacts.filter(x => x.contactId != dataItem.contactId);
		this.refreshContactsHandler(updatedCustomerObject);
	}

	refreshContactsHandler(updatedCustomerObject: CustomerObjectWithContactsDto) {
		this.loading = true;
		updatedCustomerObject.ignoreAddressCheck = true;
		this.customerObjectsService.updateCustomerObjectWithContacts(updatedCustomerObject).subscribe(resp => {
			updatedCustomerObject.ignoreAddressCheck = false;
			this.customerObjectsService.getCustomerObjectWithContacts(this.customerObjectId).subscribe(resp => {
				this.customerObject = resp;
				this.loading = false;
			});
		})
	}

	createNewContact(): CustomerObjectContactDto {
		var contact = new CustomerObjectContactDto();
		return contact;
	}

	addNewContact() {
		this.contactsGrid.addRow(this.createNewContact());
	}

	toggleCard() {
		this.cardOpened = !this.cardOpened;
	}


	editContactHandler({ dataItem }) {
		this.refreshMask(dataItem);
	}

	setMask(mask: string, dataItem: CustomerObjectContactDto) {
		this.cellPhoneMask = mask;
		dataItem.phoneNumber = '';
	}

	refreshMask(dataItem: CustomerObjectContactDto) {
		setTimeout(() => {
			this.cellPhoneMask = this.countryPhoneMasksComponent.getAndSetPhoneMask(dataItem.phoneNumber);
		}, 10);
	}

	public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

	get customerObjectExist() {
		return this.customerObjectId && this.customerObjectId != 0;
	}

	getContragentContactDisplayName(contact: CustomerObjectContactDto): string {
		return resolveContragentContactDisplayName(this.customerObject ? this.customerObject.contragentName : null, contact);
	}
}
